// extracted by mini-css-extract-plugin
export default {"banner":"BannerTitle_banner__KMknf","underline":"BannerTitle_underline__3F-KR","breadcrumb":"BannerTitle_breadcrumb__cVgNb"};